(function lawBookControllerDefinition() {
    'use strict';

    angular.module('LawBook')
        .controller('LawBookDetailController', [
            '$scope', '$translate', '$state', 'errorsExtend', '$stateParams', 'documentService', 'fileService', 'fileDownloader', 'authExtend', 'auth', 'alerts', '$q', 'storageService', 'documentAction', 'documentTypeService', '$filter',
            function lawBookDetailController($scope, $translate, $state, errors, $stateParams, documentService, fileService, fileDownloader, authExtend, auth, alerts, $q, storageService, documentAction, documentTypeService, $filter) {
                //$scope.hasOCR = authExtend.isInRole('OCR');
                //$scope.hasFullText = authExtend.isInRole('FULLTEXT');
                //$scope.PendingOcr = 'PO';

                //$scope.activiti = authExtend.isInRole('ACTIVITI');
                //$scope.canStartWorkflow = authExtend.isInRole('WORKFLOW START PROCESS');
                //$scope.canCheckInAndStartWorkflow = authExtend.isInRole('WORKFLOW START PROCESS');

                $scope.UserId = authExtend.getUserId();
                $scope.ouName = authExtend.getOrganizationName();
                $scope.urlFind = undefined;
                $scope.hasHash = false;
                $scope.isDocumentLoaded = false;
                $scope.hasFilesFromSystems = false;
                $scope.metadataAccordionOpened = true;
                $scope.filesAccordionOpened = true;
                $scope.canSign = true;
                $scope.hasSignableFiles = false;
                //$scope.workflowAccordionOpened = true;
                //$scope.workflows = [];

                $scope.loadActions = function () {
                    if ($scope.document.documentTypes.length === 0) {
                        return;
                    }

                    documentTypeService.isDoctypeInRole(['LAWBOOK DOWNLOAD'], $scope.document.documentTypes[0].documentTypeId).then(function (r) { $scope.downloadBtn = r; });
                    documentTypeService.isDoctypeInRole(['LAWBOOK SIGN'], $scope.document.documentTypes[0].documentTypeId).then(function (r) { $scope.canBeSigned = r; });
                    documentTypeService.isDoctypeInRole(['LAWBOOK WRITE'], $scope.document.documentTypes[0].documentTypeId).then(function (r) {
                        var estado = $scope.getStateDocument($scope.document);
                        $scope.modifyOptions = r && estado !== '06' && estado !== '103' && estado !== 'E';
                    });
                }

                $scope.sign = function () {
                    $state.go('lawbook-sign', { id: $scope.document.id });
                }

                $scope.initDocumentFind = function () {
                    if (storageService.getStateBackFind()) {
                        $state.go(storageService.getStateBackFind());
                    } else {
                        $state.go('lawbook-find');
                    }
                };

                $scope.openAccordion = function () {
                    if ($scope.isDocumentLoaded) {
                        $scope.accordionOpened = !$scope.accordionOpened;
                        $scope.document.files.forEach(function (item) {
                            item.accordionIsOpen = $scope.accordionOpened;
                        });
                        $scope.document.files.forEach(function (file) {
                            fileService.getSignatures(file.id).then(function (result) {
                                file.signatures = result;
                            }, function (error) {
                                errors.showError(error);
                            });
                        });
                    }
                };

                $scope.openMetadataAccordion = function () {
                    if ($scope.isDocumentLoaded) {
                        $scope.metadataAccordionOpened = !$scope.metadataAccordionOpened;
                    }
                };

                $scope.openFilesAccordion = function () {
                    if ($scope.isDocumentLoaded) {
                        $scope.filesAccordionOpened = !$scope.filesAccordionOpened;
                    }
                };

                $scope.cancel = function () {
                    if (storageService.getStateBackFind()) {
                        $state.go(storageService.getStateBackFind());
                    } else {
                        $state.go('lawbook-find');
                    }
                };

                $translate(['LawBookDetail']).then(function (translated) {
                    $scope.title = translated.LawBookDetailTitle;
                });

                $scope.loadDocument = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    if ($stateParams.nro) {
                        documentService.getVersion($stateParams.id, $stateParams.nro).then(function (result) {
                            defered.resolve(result);
                        }, function (error) {
                            defered.reject(error);
                        });
                    } else {
                        documentService.getById($stateParams.id, false).then(function (result) {
                            defered.resolve(result);
                        }, function (error) {
                            defered.reject(error);
                        });
                    }

                    return promise;
                }

                $scope.load = function () {
                    $scope.btnLogistic = false;
                    $scope.urlFind = storageService.getStateBackFind();

                    $scope.loadDocument().then(function (result) {
                        $scope.document = result;
                        $scope.loadActions();

                        $scope.document.hasMetadata = ($scope.metadataCount(result) !== 0);
                        $scope.document.documentTypes.forEach(function (docType) {
                            docType.metadatas.sort(function (a, b) {
                                return a.position - b.position;
                            });
                        });

                        if ($scope.downloadBtn) {
                            $scope.downloadBtn = ($scope.document.files.length > 0);
                        }

                        $scope.document.files_F = [];
                        $scope.document.files_A = [];
                        $scope.document.files.forEach(function (file) {

                            file.fsize = fileService.FormatfileSize(file.size);


                            if (file.isSystemCreated) {
                                //si tiene al menos un doc con imagenes, y habilitado el modulo, muestro el btn.
                                $scope.hasFilesFromSystems = true;
                            }

                            if (!angular.isDefined(file.resultadoHash)) {
                                file.resultadoHash = "notCalculated";
                                if (file.hasHash) {
                                    $scope.hasHash = true;
                                }
                            }

                            if (file.maxSigners > 0) {
                                $scope.hasSignableFiles = true;
                                $scope.document.files_F.push(file);
                            } else {
                                $scope.document.files_A.push(file);
                            }

                        });

                        var estado = $scope.getStateDocument($scope.document);

                        $scope.canSign = estado !== "06" && estado !== "E" && $scope.hasSignableFiles && $scope.document.files_F.length > 0;

                        $scope.isDocumentLoaded = true;

                        if ($stateParams.containerId) {
                            $scope.document.containers.forEach(function (cont) {
                                if (cont.id.toString() === $stateParams.containerId.toString()) {
                                    $scope.containerId = $stateParams.containerId;
                                    return;
                                }
                            });
                        }

                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                }

                $scope.getStateDocument = function (document) {

                    var result = $filter('filter')(document.documentTypes[0].metadatas, { systemName: "_estadoLLS" }, true);

                    if (result && result.length > 0) {
                        return result[0].metadataValue;
                    }
                }

                $scope.viewPDF = function (file) {
                    if (file) {
                        $state.go('file-document-detail-one', { id: $stateParams.id, version: $scope.document.versionId, file: file.id });
                    } else {
                        $state.go('file-document-detail', { id: $stateParams.id, version: $scope.document.versionId });
                    }
                };

                $scope.openFileAccordion = function (file) {
                    if ($scope.isDocumentLoaded) {
                        fileService.getSignatures(file.id).then(function (result) {
                            file.signatures = result;
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.signPDF = function (file) {
                    if (file) {
                        $state.go('file-document-sign', {
                            id: $stateParams.id,
                            version: $scope.document.versionId,
                            file: file.id
                        });
                    }
                };

                $scope.downloadFile = function (file) {
                    return fileService.download(file.id).then(function (result) {
                        var success = fileDownloader.saveAs(result, file.name);
                        if (!success) {
                            errors.showError('Api failed');
                        }

                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }
                    });
                }

                $scope.downloadFilesDocument = function () {
                    return documentAction.downloadFiles($scope.document);
                }

                $scope.hashFilesDocument = function () {
                    $scope.document.files.forEach(function (item) {
                        $scope.validateHashFile(item);
                    });
                }

                $scope.modify = function () {
                    $state.go('lawbook-edit', { id: $stateParams.id });
                }

                $scope.metadataCount = function (document) {
                    if (document.documentTypes && document.documentTypes.length) {
                        return document.documentTypes.reduce(function (valorPrevio, valorActual, indice, array) { return valorPrevio + valorActual.metadatas.length; }, 0);
                    }
                    return 0;
                };

                $scope.load();
            }
        ]);
})();